import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  PurchaseMethodFirestoreResponse,
  CreatePurchaseMethodDto,
  UpdatePurchaseMethodDto,
  DeletePurchaseMethodResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const PurchaseMethodResponseSchema = PurchaseMethodFirestoreResponse;
export const CreatePurchaseMethodSchema = CreatePurchaseMethodDto;
export const UpdatePurchaseMethodSchema = UpdatePurchaseMethodDto;

// ====== Type Exports ======
export type PurchaseMethodResponse = z.infer<typeof PurchaseMethodFirestoreResponse>;
export type CreatePurchaseMethod = z.infer<typeof CreatePurchaseMethodDto>;
export type UpdatePurchaseMethod = z.infer<typeof UpdatePurchaseMethodDto>;

// API factory function
export function createPurchaseMethodsApi(client: TypedApiClient) {
  return {
    getPurchaseMethods: (): Promise<PurchaseMethodResponse[]> => {
      return client.get('/purchase-methods', {
        responseSchema: z.array(PurchaseMethodFirestoreResponse),
      });
    },

    createPurchaseMethod: (data: CreatePurchaseMethod): Promise<PurchaseMethodResponse> => {
      return client.post('/purchase-methods', {
        data,
        requestSchema: CreatePurchaseMethodDto,
        responseSchema: PurchaseMethodFirestoreResponse,
      });
    },

    updatePurchaseMethod: (id: string, data: UpdatePurchaseMethod): Promise<PurchaseMethodResponse> => {
      return client.patch(apiPath`/purchase-methods/${id}`, {
        data,
        requestSchema: UpdatePurchaseMethodDto,
        responseSchema: PurchaseMethodFirestoreResponse,
      });
    },

    deletePurchaseMethod: (id: string): Promise<z.infer<typeof DeletePurchaseMethodResponseDto>> => {
      return client.delete(apiPath`/purchase-methods/${id}`, {
        responseSchema: DeletePurchaseMethodResponseDto,
      });
    },
  };
}
